import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import categoryService from '../../api/categoryService';

export default class ConfirmDeleteCategory extends Component {
    constructor(props) {
        super(props);

        this.deleteCategory = this.deleteCategory.bind(this);
    }

    deleteCategory() {
        const { id } = this.props.category;
        categoryService.deleteCategory(id)
            .then(() => {
                this.props.onClose();
            });
    }

    render() {
        const { showConfirm, onClose, category } = this.props;
        if (category) {
            return (
                <Dialog
                    open={showConfirm}
                    onClose={onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Delete category?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            You are deleting '{category.name}'. Any children attached to this category will be deleted too.
                            Do you want to proceed?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">No, go back</Button>
                        <Button onClick={this.deleteCategory} color="primary" autoFocus>Yes</Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    }
}